import React, { ReactNode } from "react"
import { classNames } from "../Components"
import { Icon, IconType } from "./Icon"
import { Menu } from "./Menu"

export interface MenuStatusInfo {
  icon: IconType;
  class: string;
  surface?: "filled" | "outlined";
}

interface MenuStatusButtonProps extends Omit<React.ComponentProps<typeof Menu>, "button"> {
  info: MenuStatusInfo;
  title?: string | ReactNode;
}

export function MenuStatusButton({ info, title, buttonClass, ...menuProps }: MenuStatusButtonProps) {
  const surface = info.surface ?? "outlined";
  return (
    <Menu
      button={<><Icon className={classNames(["ShipView-status-marker", info.class])} icon={info.icon} /> {title}</>}
      buttonClass={classNames(["MenuStatusButton", `MenuStatusButton-${surface}`, info.class, buttonClass])}
      {...menuProps}
    />
  );
}
